import * as React from "react";
import type { SVGProps } from "react";
const SvgPm1Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="pm1_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M853.333 170.667A42.667 42.667 0 0 1 896 213.333v469.334a42.667 42.667 0 0 1-42.667 42.666H298.667A42.667 42.667 0 0 1 256 682.667V213.333a42.667 42.667 0 0 1 42.667-42.666h554.666zM298.667 85.333a128 128 0 0 0-128 128v469.334a128 128 0 0 0 128 128h554.666a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H298.667zm119.381 200.534c33.45 0 61.867 10.538 82.133 29.184 20.31 18.73 31.488 44.842 31.488 74.24 0 29.354-11.178 55.466-31.488 74.24-20.224 18.602-48.725 29.141-82.133 29.141h-58.795v117.461h-73.386V285.867h132.266zm213.333 0 83.883 169.557 82.304-169.557h68.565v324.266h-73.386v-158.08l-51.755 103.979h-51.157l-53.632-105.13v159.231h-73.387V285.867h68.523zM359.168 425.984h56.192c14.379 0 25.045-3.925 31.915-9.856 6.656-5.717 11.008-14.421 11.008-26.88 0-12.416-4.352-21.248-11.094-27.093-6.826-6.016-17.536-9.984-31.829-9.984h-56.15v73.813zM128 384a42.667 42.667 0 0 0-85.333 0v341.333A213.333 213.333 0 0 0 256 938.667h341.333a42.667 42.667 0 1 0 0-85.334H256a128 128 0 0 1-128-128V384z"
    />
  </svg>
);
export default SvgPm1Icon;
